import React, { memo, useState } from 'react'
import { Box, Typography, Switch, FormControlLabel } from '@material-ui/core'

import { useTranslation } from 'react-i18next'

import { CookieDetailsCard } from '../'

import constants from 'constants/index'
import sharedStyles from '../styles'
import useCookiesSectionStyles from './styles'

const CookiesSection = () => {
  const { t } = useTranslation()
  const [enabled, setEnabled] = useState({})
  const shared = sharedStyles()
  const classes = useCookiesSectionStyles()

  const toggle = (id) => setEnabled((prev) => ({ ...prev, [id]: !prev[id] }))

  return (
    <Box className={classes.root}>
      <Typography variant="body1" className={shared.description}>
        {t('menu.cookieSection.description')}
      </Typography>
      <Box className={shared.container}>
        {constants.cookies.category.MENU_ITEMS.map((cat) => {
          const checked = !!enabled[cat.id]
          return (
            <Box key={cat.id} className={classes.categoryCard}>
              <Box className={classes.categoryHeader}>
                <Typography className={classes.categoryTitle}>
                  {t(cat.translateKey)}
                </Typography>
                {cat.alwaysActive ? (
                  <Typography
                    variant="caption"
                    color="primary"
                    className={classes.alwaysActive}
                  >
                    {t('card.alwaysActive')}
                  </Typography>
                ) : (
                  <FormControlLabel
                    control={
                      <Switch
                        color="secondary"
                        checked={checked}
                        onChange={() => toggle(cat.id)}
                      />
                    }
                    label={t('switch.activateLabel')}
                  />
                )}
              </Box>
              <Box className={classes.detailsWrapper}>
                <CookieDetailsCard categoryId={cat.id} />
              </Box>
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}

export default memo(CookiesSection)
